import { Icon } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';

export const ThermometerIcon = (props: Omit<IconProps, 'children' | 'viewBox'>) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='100%'
    {...props}
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <path d='M10 13.5a4 4 0 1 0 4 0V5a2 2 0 0 0-4 0v8.5' />
    <path d='M10 9h4' />
  </Icon>
);

export default ThermometerIcon;
